import { useDragOperation } from "@dnd-kit/react";

import {
  ITEM_MOVE_DRAG_TYPE,
  isItemMoveDragData,
} from "../item-move-dnd";

export function useIsItemMoveDragging() {
  const { source } = useDragOperation();

  return (
    source?.type === ITEM_MOVE_DRAG_TYPE &&
    isItemMoveDragData(source.data)
  );
}
